import axios from 'axios'
import { getAuthFromStorage } from '../helpers'

// Переключение между dev и prod серверами
const baseURL = 'https://kornidali.com/'
// const baseURL = 'https://777dev.ru:3333/'
console.log(baseURL)

export const api = axios.create({
	baseURL: baseURL,
	timeout: 20000,
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
})

api.interceptors.request.use((req) => {
	const { access_token } = getAuthFromStorage()
	if (access_token) {
		req.headers = {
			...req.headers,
			Authorization: `Bearer ${access_token}`,
		}
	}
	return req
})
